import * as React from 'react';

import type { ThreadFilters } from '@/api/chat-client';
import type { ChatSocketLike } from '@/api/chat-realtime';
import { ChatWorkspace } from '@/routes/communication/chat-workspace';

// =============================================================================
// admin-conversations-screen.tsx — ADMIN « Conversations » (R15-COM-02, surface miroir).
// =============================================================================
// Vue scindée admin : liste des fils (SIRET, campagne, aperçu, récence, badge non-lus) + recherche SIRET
// (`q`) + filtres (campagne, non-lus) + fil chronologique avec composition. Le composant est PRÉSENTATIONNEL
// (props d'état d'URL) : l'adaptateur routeur (admin-conversations-route) porte le search-state (RULE_REF_006).

export interface AdminConversationsScreenProps {
  readonly filters: ThreadFilters;
  readonly onFiltersChange: (filters: ThreadFilters) => void;
  readonly selectedThreadId: string | null;
  readonly onSelectThread: (threadId: string | null) => void;
  /** Fabrique de socket injectable (tests). */
  readonly socketFactory?: () => ChatSocketLike;
}

export function AdminConversationsScreen({
  filters,
  onFiltersChange,
  selectedThreadId,
  onSelectThread,
  socketFactory,
}: AdminConversationsScreenProps): React.JSX.Element {
  return (
    <ChatWorkspace
      profile="admin"
      title="Conversations"
      description="Échanges 1-to-1 avec les fournisseurs, par campagne. Le contenu est chargé en temps réel."
      filters={filters}
      onFiltersChange={onFiltersChange}
      selectedThreadId={selectedThreadId}
      onSelectThread={onSelectThread}
      showAdminControls
      {...(socketFactory !== undefined ? { socketFactory } : {})}
    />
  );
}
